import * as React from 'react';
import Button from '@mui/material/Button';
import { useAuth0 } from "@auth0/auth0-react";

//Images, Styles
import styles from './login.module.scss';
import logo from '../logo.svg';

const LoginButton = () => {
    const { loginWithRedirect } = useAuth0();

    return (
        <Button
            variant="outlined"
            className={styles.LoginButton}
            onClick={() => loginWithRedirect()}
        >
            Login with Auth0
        </Button>
    );
};

//Login Page Component. Provides the context for login and authentication
const LoginPage = (): JSX.Element => {
    return (
        <div>
            <div className={styles.Title}>
                <img src={logo} alt="OPUS logo" style={{ height: '10vh' }}/>
                <h1 style={{ fontSize: '10vh' }}>
                    O P U S
                </h1>
            </div>
            <div className={styles.Disclaimer}>
                <p>DISCLAIMER: This material is intended as a guide to various state requirements. Please refer to the referenced statutes for additional information and contact the legal department with further questions, or if you need clarification.</p>
            </div>
            <div className={styles.LogInContainer}>
                <LoginButton />
            </div>
        </div>
    );
};

export default LoginPage;
